<template>
<div class="welcome-menu">

  <vue-headful
    title="TZ Design Box - Welcome"
    description="TZ Design Box"
/>

<section class="section welcome-sec">
    <div class="container">
      <div class="columns">
        <div class="column" style="margin-top:25px;">{{ $t("welcome") }}

        </div>
      </div>
    </div>
</section>
</div>
</template>

<script>
export default{
    name:'Welcome'
}
</script>

<style>
</style>
